import { Tabs } from '@mantine/core';
import { useTranslation } from 'next-i18next';

import { ActivityThemeStyles } from 'shared/types/Theme';

import { Background } from './configPartials/Background';
import { Borders } from './configPartials/Borders';
import { Corners } from './configPartials/Corners';
import { Layout } from './configPartials/Layout';
import { Position } from './configPartials/Position';
import { Shadow } from './configPartials/Shadow';
import { ConfigTitleBase } from '@/widgets/_components/ConfigTitle/ConfigTitleBase';
import { WidgetConfig } from '@/widgets/_components/WidgetConfig';

export type TooltipConfigProps = {
  styles: Partial<ActivityThemeStyles['tooltip']>;
  resolvedStyles: ActivityThemeStyles['tooltip'];
  onUpdateStyle: (styleToUpdate: Partial<ActivityThemeStyles['tooltip']>) => void;
  onRemoveStyle: (styleKey: keyof ActivityThemeStyles['tooltip']) => void;
};

export function TooltipConfig(props: TooltipConfigProps) {
  const { t } = useTranslation('components', { keyPrefix: 'theme.settings' });

  return (
    <WidgetConfig customTitle={<ConfigTitleBase title={t('tooltip.title')} />} tabs={['appearance']}>
      <Tabs.Panel key="appearance" value="appearance">
        <Background {...props} />
        <Corners {...props} />
        <Borders {...props} />
        <Shadow {...props} />
        <Position {...props} />
        <Layout {...props} />
      </Tabs.Panel>
    </WidgetConfig>
  );
}
